require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-shrinking-civic-space-how-can-the-world-bank-respond.json") })
        }
      }, "path---en-us-update-shrinking-civic-space-how-can-the-world-bank-respond");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-shrinking-civic-space-how-can-the-world-bank-respond!./.cache/json/en-us-update-shrinking-civic-space-how-can-the-world-bank-respond.json
// module id = 791
// module chunks = 231608221292675